import { Plugin } from 'prosemirror-state';

import { AddMenuFile, FileOutline } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import { NODE_NAME } from '../consts';
import FileNodeView from './NodeView';

function plugins({ createReactNodeView, t }: EditorOptions) {
  return [
    new Plugin({
      props: {
        nodeViews: {
          file(node, view, getPos, decorations) {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              component: FileNodeView,
            });
          },
        },
      },
    }),
    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.file.title') as string,
            description: t('Lygo:Menu.file.description') as string,
            icon: FileOutline,
            addMenuIcon: AddMenuFile,
            addMenuItemType: addMenuItemType.media,
            attrs: { href: null },
            searchWords: ['file', 'media', 'upload'],
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
